/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderInfoForSplitVo } from './OrderInfoForSplitVo';
import {
    OrderInfoForSplitVoFromJSON,
    OrderInfoForSplitVoFromJSONTyped,
    OrderInfoForSplitVoToJSON,
    OrderInfoForSplitVoToJSONTyped,
} from './OrderInfoForSplitVo';

/**
 * 
 * @export
 * @interface ResponseOrderInfoForSplitVo
 */
export interface ResponseOrderInfoForSplitVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseOrderInfoForSplitVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseOrderInfoForSplitVo
     */
    message?: string;
    /**
     * 
     * @type {OrderInfoForSplitVo}
     * @memberof ResponseOrderInfoForSplitVo
     */
    data?: OrderInfoForSplitVo;
}

/**
 * Check if a given object implements the ResponseOrderInfoForSplitVo interface.
 */
export function instanceOfResponseOrderInfoForSplitVo(value: object): value is ResponseOrderInfoForSplitVo {
    return true;
}

export function ResponseOrderInfoForSplitVoFromJSON(json: any): ResponseOrderInfoForSplitVo {
    return ResponseOrderInfoForSplitVoFromJSONTyped(json, false);
}

export function ResponseOrderInfoForSplitVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseOrderInfoForSplitVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : OrderInfoForSplitVoFromJSON(json['data']),
    };
}

export function ResponseOrderInfoForSplitVoToJSON(json: any): ResponseOrderInfoForSplitVo {
    return ResponseOrderInfoForSplitVoToJSONTyped(json, false);
}

export function ResponseOrderInfoForSplitVoToJSONTyped(value?: ResponseOrderInfoForSplitVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': OrderInfoForSplitVoToJSON(value['data']),
    };
}

